import sliderMain from '../images/slider.jpg';
import sliderAlt from '../images/slider1.jpeg';
import allImage from '../images/all.png';
import allImageTwo from '../images/all2.png';
import patnaImage from '../images/patna.png';
import bhagalpurImage from '../images/bhagalpur.png';
import darbhangaImage from '../images/dbg.png';
import darbhangaImageOne from '../images/dbg-1.png';
import darbhangaMuzaffarpurImage from '../images/dbg-mzp.png';
import farbisganjImage from '../images/farbisganj.png';
import generalHighlightImage from '../images/ghfdsdfghjkl.png';
import gopalganjImage from "../images/gopalganj'.png";
import kushinagarImage from '../images/kushinagar-up.png';
import motharImage from '../images/mothar.png';
import motoMuzzImage from '../images/moto-muzz.png';
import muzaffarpurImage from '../images/muz.png';
import mzpOneImage from '../images/mzp1.png';
import mzzzpImage from '../images/mzzzp.png';
import nepalDualImage from '../images/nepa-dono.png';
import doctorOne from '../images/doc1.jpeg';
import doctorTwo from '../images/doc2.jpeg';
import doctorThree from '../images/doc3.jpeg';
import profileOne from '../images/profile1.jpeg';
import profileTwo from '../images/profile2.jpeg';
import purniaImage from '../images/purnia.png';
import awardImage from '../images/award.jpeg';
import awardOne from '../images/award/award-1.jpeg';
import awardTwo from '../images/award/award-2.jpeg';
import awardThree from '../images/award/award-3.jpeg';
import awardFour from '../images/award/award-4.jpeg';
import awardFive from '../images/award/award-5.jpeg';
import awardSix from '../images/award/award-6.jpeg';
import awardSeven from '../images/award/award-7.jpeg';
import awardEight from '../images/award/award-8.jpeg';
import awardNine from '../images/award/award-9.jpeg';
import awardTen from '../images/award/award-10.jpeg';
import awardEleven from '../images/award/award-11.jpeg';
import awardTwelve from '../images/award/award-12.jpeg';
import awardThirteen from '../images/award/award-13.jpeg';
import awardFourteen from '../images/award/award-14.jpeg';
import bhagalpurVideo from '../images/bhagalpur.mp4';
import crpfVideo from '../images/crpf_video.mp4';
import muzaffarpurVideo from '../images/muzaffarpur-.mp4';
import muzaffarpurInsulineVideo from '../images/muzaffarpur_insuline.mp4';
import nepalVideo from '../images/Nepal .mp4';
import nepalAltVideo from '../images/nepal.mp4';
import nepaliVideo from '../images/nepali.mp4';
import newVideo from '../images/new.mp4';
import testimonialOneVideo from '../images/testmonial1.mp4';
import testimonialTwoVideo from '../images/testimonial2.mp4';
import testimonialThreeVideo from '../images/testimonial3.mp4';
import testimonialFourVideo from '../images/testimonial4.mp4';
import testimonialSixVideo from '../images/testimonial6.mp4';
import testimonialSevenVideo from '../images/testimonial7.mp4';
import testimonialNineVideo from '../images/testimonial9.mp4';

export const heroSlides = [
  {
    id: 1,
    image: sliderMain,
    eyebrow: '20+ years of trusted care',
    title: 'Uttam Diabetes Care & Research Center',
    subtitle: 'मधुमेह, इंसुलिन और किडनी से जुड़ी देखभाल अब अनुभवी मार्गदर्शन के साथ',
    description:
      'Personalized diabetes management, disciplined follow-up, and compassionate support for families across Bihar and nearby regions.',
    stats: [
      { label: 'Patients Guided', value: '10,000+' },
      { label: 'Years of Service', value: '20+' },
      { label: 'Cities Connected', value: '10+' },
    ],
  },
  {
    id: 2,
    image: sliderAlt,
    eyebrow: 'Hindi-friendly consultation support',
    title: 'स्पष्ट सलाह, सरल भाषा, बेहतर समझ',
    subtitle: 'हिंदी बोलने वाले मरीजों और परिवारों के लिए उपचार की हर बात आसान तरीके से समझाई जाती है',
    description:
      'From sugar control to kidney support, we focus on helping patients understand every step of treatment with confidence.',
    stats: [
      { label: 'Hindi Support', value: '100%' },
      { label: 'Follow-up Focus', value: 'Regular' },
      { label: 'Care Model', value: 'Holistic' },
    ],
  },
  {
    id: 3,
    image: patnaImage,
    eyebrow: 'Real clinic experience',
    title: 'Advanced care with a human touch',
    subtitle: 'Consultation, diet guidance, monitoring, and lifestyle direction in one connected care journey',
    description:
      'We blend clinical discipline with patient-centered guidance so long-term care feels structured, supportive, and professional.',
    stats: [
      { label: 'Doctor-led Care', value: 'MD' },
      { label: 'Care Path', value: 'Structured' },
      { label: 'Patient First', value: 'Always' },
    ],
  },
];

export const introHighlights = [
  'डायबिटीज, इंसुलिन और किडनी से जुड़ी समस्याओं के लिए अनुभवी मार्गदर्शन',
  'हिंदी में सरल समझाइश ताकि मरीज और परिवार उपचार को ठीक से समझ सकें',
  'आहार, दिनचर्या, फॉलो-अप और नियमित मॉनिटरिंग पर विशेष ध्यान',
  'लंबी अवधि के बेहतर स्वास्थ्य के लिए व्यवस्थित और व्यक्तिगत देखभाल',
];

export const galleryImages = [
  { src: allImage, alt: 'Diabetes care collage visual 1' },
  { src: allImageTwo, alt: 'Diabetes care collage visual 2' },
  { src: awardImage, alt: 'Recognition and award moment' },
  { src: bhagalpurImage, alt: 'Bhagalpur center visual' },
  { src: darbhangaImage, alt: 'Darbhanga center visual' },
  { src: darbhangaImageOne, alt: 'Darbhanga consultation visual' },
  { src: darbhangaMuzaffarpurImage, alt: 'Darbhanga and Muzaffarpur center visual' },
  { src: farbisganjImage, alt: 'Forbesganj center visual' },
  { src: generalHighlightImage, alt: 'Patient care poster visual' },
  { src: gopalganjImage, alt: 'Gopalganj center visual' },
  { src: kushinagarImage, alt: 'Kushinagar center visual' },
  { src: motharImage, alt: 'Motihari center visual' },
  { src: motoMuzzImage, alt: 'Motihari and Muzaffarpur center visual' },
  { src: patnaImage, alt: 'Patna center consultation area' },
  { src: muzaffarpurImage, alt: 'Muzaffarpur center visual' },
  { src: mzpOneImage, alt: 'Muzaffarpur center visual 2' },
  { src: mzzzpImage, alt: 'Muzaffarpur center visual 3' },
  { src: nepalDualImage, alt: 'Regional outreach center visual' },
  { src: doctorOne, alt: 'Doctor consultation moment' },
  { src: doctorTwo, alt: 'Clinical support team' },
  { src: doctorThree, alt: 'Patient guidance session' },
  { src: profileOne, alt: 'Patient testimonial portrait' },
  { src: profileTwo, alt: 'Patient testimonial portrait 2' },
  { src: purniaImage, alt: 'Purnia center visual' },
  { src: sliderMain, alt: 'Clinic hero visual' },
  { src: sliderAlt, alt: 'Consultation hero visual 2' },
];

export const videoHighlights = [
  {
    id: 1,
    title: 'Patient care highlight',
    poster: patnaImage,
    src: newVideo,
  },
  {
    id: 2,
    title: 'Center walkthrough',
    poster: muzaffarpurImage,
    src: crpfVideo,
  },
  {
    id: 3,
    title: 'Treatment journey glimpse',
    poster: nepalDualImage,
    src: bhagalpurVideo,
  },
  {
    id: 4,
    title: 'Muzaffarpur center visit',
    poster: mzpOneImage,
    src: muzaffarpurVideo,
  },
  {
    id: 5,
    title: 'Insulin support guidance',
    poster: muzaffarpurImage,
    src: muzaffarpurInsulineVideo,
  },
  {
    id: 6,
    title: 'Nepal outreach highlight',
    poster: nepalDualImage,
    src: nepalVideo,
  },
  {
    id: 7,
    title: 'Nepal clinic journey',
    poster: allImage,
    src: nepalAltVideo,
  },
  {
    id: 8,
    title: 'Nepali patient support highlight',
    poster: allImageTwo,
    src: nepaliVideo,
  },
  {
    id: 9,
    title: 'Patient testimonial 1',
    poster: profileOne,
    src: testimonialOneVideo,
  },
  {
    id: 10,
    title: 'Patient testimonial 2',
    poster: profileTwo,
    src: testimonialTwoVideo,
  },
  {
    id: 11,
    title: 'Patient testimonial 3',
    poster: doctorOne,
    src: testimonialThreeVideo,
  },
  {
    id: 12,
    title: 'Patient testimonial 4',
    poster: doctorTwo,
    src: testimonialFourVideo,
  },
  {
    id: 13,
    title: 'Patient testimonial 6',
    poster: doctorThree,
    src: testimonialSixVideo,
  },
  {
    id: 14,
    title: 'Patient testimonial 7',
    poster: bhagalpurImage,
    src: testimonialSevenVideo,
  },
  {
    id: 15,
    title: 'Patient testimonial 9',
    poster: purniaImage,
    src: testimonialNineVideo,
  },
];

export const awardGalleryImages = [
  { src: awardOne, alt: 'Award ceremony highlight 1' },
  { src: awardTwo, alt: 'Award ceremony highlight 2' },
  { src: awardThree, alt: 'Award ceremony highlight 3' },
  { src: awardFour, alt: 'Award ceremony highlight 4' },
  { src: awardFive, alt: 'Award ceremony highlight 5' },
  { src: awardSix, alt: 'Award ceremony highlight 6' },
  { src: awardSeven, alt: 'Award ceremony highlight 7' },
  { src: awardEight, alt: 'Award ceremony highlight 8' },
  { src: awardNine, alt: 'Award ceremony highlight 9' },
  { src: awardTen, alt: 'Award ceremony highlight 10' },
  { src: awardEleven, alt: 'Award ceremony highlight 11' },
  { src: awardTwelve, alt: 'Award ceremony highlight 12' },
  { src: awardThirteen, alt: 'Award ceremony highlight 13' },
  { src: awardFourteen, alt: 'Award ceremony highlight 14' },
];

export const testimonials = [
  {
    id: 1,
    type: 'video',
    name: 'Patient Story',
    location: 'Bhagalpur region',
    quote: 'वीडियो अनुभव में उपचार, विश्वास और परिवार की राहत एक साथ दिखाई देती है।',
    poster: patnaImage,
    src: bhagalpurVideo,
  },
  {
    id: 2,
    type: 'video',
    name: 'Family Feedback',
    location: 'Patna region',
    quote: 'हिंदी में साफ समझाइश और नियमित फॉलो-अप ने पूरे परिवार का भरोसा मजबूत किया।',
    poster: muzaffarpurImage,
    src: newVideo,
  },
  {
    id: 3,
    type: 'image',
    name: 'Renu Devi',
    location: 'Muzaffarpur',
    quote:
      'डॉक्टर साहब ने शुगर, खान-पान और दवा की पूरी जानकारी सरल हिंदी में समझाई। अब हम इलाज को लेकर ज्यादा confident हैं।',
    image: profileOne,
  },
  {
    id: 4,
    type: 'image',
    name: 'Ajay Kumar',
    location: 'Patna',
    quote:
      'Treatment planning bahut systematic laga. Reports dekhkar clear guidance milti rahi aur follow-up bhi professional tha.',
    image: profileTwo,
  },
];

export const centers = [
  {
    id: 1,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'पटना',
    address: 'नहर रोड, न्यू अरफाबाद कॉलोनी, बजरंग पुरी, गायघाट, पटना, भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: patnaImage,
  },
  {
    id: 2,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'मुजफ्फरपुर',
    address: 'अघोरिया बाजार चौराहा, शिव मंदिर के बगल में,  मुजफ्फरपुर, बिहार, भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: muzaffarpurImage,
  },
  {
    id: 3,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'मोतिहारी',
    address: ' पंच मंदिर चौक, मंदिर के पीछे, मोतिहारी, बिहार , भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: sliderAlt,
  },
  {
    id: 4,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'सीवान',
    address: 'केन्द्रीय विद्यालय बाईपास रोड, नियर दरोगा राय कॉलेज, सिवान, बिहार, भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: doctorOne,
  },
  {
    id: 5,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'गोपालगंज',
    address: 'राजवाही कॉलोनी वार्ड नं.1, यादवपुर, चौक लखपतियों मोड़, गोपालगंज,बिहार,भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: doctorTwo,
  },
  {
    id: 6,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'पूर्णिया',
    address: 'कटिहार मोड़ से आगे, खुशीयाबाग,  गैस एजेंसी के सामने, पूर्णिया, बिहार, भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: nepalDualImage,
  },
  {
    id: 7,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'भागलपुर',
    address: 'हाउसिंग बोर्ड कॉलोनी, नियर शिव मंदिर, बरारी रोड, भागलपुर, बिहार, भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: awardImage,
  },
  {
    id: 8,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'फारबिशगंज',
    address: 'सुभाष चौक, फारबिसगंज, अररिया , बिहार, भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: doctorThree,
  },
  {
    id: 9,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'कुशीनगर',
    address: 'कसिया, ओवरब्रिज के पास, संत जेवियर स्कूल के नजदीक, कुशीनगर, उत्तर प्रदेश',
    note: 'Address aligned with the publicly listed Kushinagar center.',
    phone: '+91 84908 37799',
    image: sliderMain,
  },
  {
    id: 10,
    name: 'उत्तम डायबिटीज केयर एवं रिसर्च सेंटर',
    city: 'दरभंगा',
    address: 'सैदनगर पेट्रोल पम्प के सामने लहेरियासराय, दरभंगा, बिहार भारत',
    note: 'Exact consultation address is shared at the time of appointment confirmation.',
    phone: '+91 99397 65562',
    image: profileTwo,
  },
];

export const aboutStats = [
  { label: 'Patients Guided', value: '10,000+' },
  { label: 'Clinical Experience', value: '20+ Years' },
  { label: 'Connected Cities', value: '10+' },
  { label: 'Hindi-first Support', value: 'Available' },
];

export const treatmentPrinciples = [
  {
    title: 'Diabetes Management Support',
    text:
      'Care planning focuses on sugar monitoring, practical diet guidance, medication discipline, and regular follow-up so patients understand how to manage daily health more confidently.',
    hindi:
      'मरीज को केवल दवा नहीं, बल्कि शुगर कंट्रोल, खान-पान, दिनचर्या और नियमित जांच की पूरी समझ देना भी इलाज का महत्वपूर्ण हिस्सा है।',
    points: [
      'Personalized consultation based on patient history',
      'Diet and routine guidance explained in simple language',
      'Monitoring support for reports and follow-up planning',
      'Family counseling where long-term care needs involvement',
    ],
  },
  {
    title: 'Kidney Wellness Guidance',
    text:
      'For patients dealing with kidney-related concerns, the clinic emphasizes disciplined review of symptoms, test reports, diet care, and timely consultation planning.',
    hindi:
      'किडनी से जुड़ी परेशानी में रिपोर्ट को समझना, सही समय पर सलाह लेना और भोजन व दिनचर्या पर नियंत्रण रखना बहुत जरूरी होता है।',
    points: [
      'Report-oriented review and progress discussion',
      'Fluid, routine, and food-related care guidance',
      'Structured follow-up recommendations',
      'Clear communication for patients and caregivers',
    ],
  },
];

export const successStories = [
  {
    title: 'Clearer Understanding, Better Discipline',
    text:
      'Many families value the way treatment decisions and precautions are explained in straightforward Hindi before each next step is planned.',
  },
  {
    title: 'Long-term Follow-up Support',
    text:
      'Patients managing diabetes over time often benefit from regular review, practical routine changes, and confidence-building guidance during follow-up.',
  },
  {
    title: 'Family-centered Communication',
    text:
      'Where a patient needs help with insulin, food planning, or kidney care, family members are also guided so day-to-day care stays consistent.',
  },
];

export const contactDetails = {
  primaryPhone: '+91 99397 65562',
  secondaryPhone: '+91 84908 37799',
  email: 'info@drsantoshkumar.co.in',
  address: 'Patna, Bihar 800001',
  addressNote: 'Exact consultation address is shared during appointment confirmation.',
  hours: 'Mon - Sat: 9:00 AM - 6:00 PM',
  supportText:
    'Hindi-speaking patients and family members can ask questions about consultation, timings, reports, and follow-up support.',
};
